module.exports = "img/social/reddit.5424a6c.png";